<template>
	<div class="globe"
	:class="[{'globe--loading': isLoading},{'globe--hide': !enabled},{'globe--over-case-ui': isCaseOpen},{'globe--is-moving': isGrabbing}, {'globe--is-meaningful-drag': meaningFullDragEventEmitted}, 'globe--state-'+globeState]">
        <!--<div class="globe__loading">{{Math.ceil(loadingPercentage)}}% loading...</div>-->
        <div class="globe__loading">loading...</div>

        <div v-if="isTutorial" class="globe__tutorial">
            <div class="globe__tutorial-hand" :class="'globe__tutorial-hand--'+tutorialAnimationState"></div>
            <div class="globe__tutorial-text">Click and drag to navigate</div>
        </div>

        <div class="globe__interaction-layer"
            @wheel='handleWheel'
            @pointerdown='handleMouseDown'
            @pointerup='handleMouseUp'
            @pointermove='handleMouseMove'>
            <div class="globe__placeholder"></div>
        </div>

        <RealtimeGlobeWithMarkers
            :enabled="enabled"
            class="globe__markers"
            :globeRotation="globeRotation"
            :markers="markers"
            :selectedCaseId="selectedCaseId"
            :viewCaseLabel="viewCaseLabel"
            @open-case="openCase"
            @doneLoading="handleDoneLoading"></RealtimeGlobeWithMarkers>
	</div>
</template>

<script>
import RealtimeGlobeWithMarkers from '@/components/RealtimeGlobeWithMarkers';
import store from '@/dataStore';

export default {
	name: 'Globe',
	props: {
		challenge: Object,
		cases: Array,
		selectedLayer: Object,
        isCaseOpen: Boolean,
		selectedCaseId: Number,
        enabled: Boolean,
        globeState: String,
        viewCaseLabel: String
	},
    components: {
        RealtimeGlobeWithMarkers
    },
	data()
	{
		return {
            isLoading: true,
            tutorialHasBeenPassed: false,
            tutorialAnimationState: 'open', // NOTE(Mølby): 'open' and 'grabbing' are the two animations states
            tutorialAnimationStateInterval: null,
            tutorialAnimationMilliseconds: 1250,

            autospinSpeed: 15,

			// NOTE(Mølby): Rotation/Drag state
			globeRotation: {x: 10, y: -104},
			dragScaleHorisontal: 0.15, // NOTE(Mølby): Update this to affect speed. The lower the slower
            dragScaleVertical: 0.10,
			isGrabbing: false,
            previousMousePosition: {x: 0, y: 0},
            totalPixelsDragged: 0,
            meaningFullDragEventEmitted: false,
            velocityX: 0,
            velocityY: 0,
            timeLastFrame: 0,
            dragLastFiveFrames: [
                {time: 0, posX: 0},
                {time: 0, posX: 0},
                {time: 0, posX: 0},
                {time: 0, posX: 0},
                {time: 0, posX: 0}
            ],
            velocityToAddNextFrame: 0,
		}	
	},
    computed:
    {
        isTutorial()
        {
          return (this.globeState === 'tutorial' && !this.tutorialHasBeenPassed && !this.isLoading);
        },
        markers()
        {
            var markerData = [];

            var colorTheme = 'red';
            if (this.challenge) colorTheme = this.challenge.colorTheme;

            // NOTE(Mølby): Create case markers
            this.cases.forEach((challengeCase)=>{
               if (challengeCase.challengeId === parseInt(this.$route.params.challengeId))
               {
                    var lat = 0;
                    var long = 0;
                    var coordinatesSplit = challengeCase.locationCoordinates.split(',');
                    if (coordinatesSplit.length === 2)
                    {
                        lat = coordinatesSplit[0];
                        long = coordinatesSplit[1];
                    }

                    markerData.push({
                        id: challengeCase.id,
                        type: 'case',
                        colorTheme: colorTheme,
                        data: {
                            caseId: challengeCase.id,
                            caseName: challengeCase.caseName,
                            locationName: challengeCase.locationName
                        },
                        coordinates: {lat: lat, long: long}
                    });
               }
            });

            // NOTE(Mølby): Create markers for selected data layer
            if (this.selectedLayer)
            {
                this.selectedLayer.dataPoints.forEach((dataPoint, i)=>{

                    var lat = 0;
                    var long = 0;
                    var coordinatesSplit = dataPoint.locationCoordinates.split(',');
                    if (coordinatesSplit.length === 2)
                    {
                        lat = coordinatesSplit[0];
                        long = coordinatesSplit[1];
                    }

                    markerData.push({
                        id: 'dp-'+i,
                        type: 'datalayer',
                        colorTheme: colorTheme,
                        data: {
                            heading: dataPoint.heading,
                            text: dataPoint.text,
                            image: dataPoint.image,
                            source: dataPoint.source
                        },
                        coordinates: {lat: lat, long: long}
                    });
                })
            }

            return markerData;
        }
    },
	mounted()
	{
        this.loadingPercentage = 0;

       this.updateLoop();
       this.updateTutorialAnimationStateLoop();
	},
    watch: {
        globeState(newState)
        {
            if (newState === 'autospin')
            {
                this.tutorialHasBeenPassed = false;
            }

            this.updateTutorialAnimationStateLoop();
        }
    },
	methods:
	{
        handleDoneLoading()
        {
            this.isLoading = false;
            this.updateTutorialAnimationStateLoop();
        },
        updateTutorialAnimationStateLoop()
        {
            if (this.isTutorial)
            {
                // NOTE(Mølby): Start tutorial animation loop

                this.tutorialAnimationState = 'open';
                setTimeout(() => {
                    this.tutorialAnimationState = 'grabbing';
                    this.velocityToAddNextFrame = -250;
                }, 500);

                this.tutorialAnimationStateInterval = setInterval(()=>{
                    if (this.tutorialAnimationState === 'grabbing')
                    {
                        this.tutorialAnimationState = 'open';
                    }
                    else {
                        this.tutorialAnimationState = 'grabbing';
                        this.velocityToAddNextFrame = -250;
                    }
                }, this.tutorialAnimationMilliseconds);
            }
            else
            {
                // NOTE(Mølby): End tutorial animation loop
                clearInterval(this.tutorialAnimationStateInterval);
            }
        },
        openCase(marker)
        {
            this.$router.push('/challenges/'+this.challenge.id+'/'+marker.data.caseId+'/');
        },
		handleWheel(event)
        {
			this.velocityX += event.deltaY * 0.4;
            // this.showDragHint = false;
        },
        updateLoop(timeThisFrame)
        {
            if (this.enabled)
            {
                if (!this.isGrabbing)
                {
                    if (this.globeState === 'autospin' && !this.isLoading)
                    {
                        this.velocityX = this.autospinSpeed;
                    }

                    var deltaTime = (timeThisFrame - this.timeLastFrame) / 1000;
                    if (deltaTime > 0)
                    {
                        /*
                        // NOTE(Mølby): Clamp max deltatime, to avoid big leaps in animation when changing tabs and similar
                        var deltaClampedThisFrame = false;
                        if (deltaTime >= 0.0333333333) 
                        {
                            deltaClampedThisFrame = true; // deltaTime = 0.03333333333;
                        }
                        */

                        // NOTE(Mølby): Move by current velocity

                        // NOTE(Mølby): Safeguard against NaN contamination
                        if (!isFinite(this.velocityX)) this.velocityX = 0;
                        if (!isFinite(this.velocityY)) this.velocityY = 0;

                        var newOffsetX = this.velocityX * deltaTime;
                        var newOffsetY = this.velocityY * deltaTime;

                        this.globeRotation.y += newOffsetX;
                        this.globeRotation.y = this.wrapRotationY(this.globeRotation.y);

                        this.globeRotation.x += newOffsetY;
                        this.globeRotation.x = this.clampRotationX(this.globeRotation.x);


                        // NOTE(Mølby): Dampen and clamp velocity
                        var maxVelocity = 4000;
                        var haltVelocity = 12;

                        // NOTE(Mølby): Set max velocity...
                        if (this.velocityX > maxVelocity)
                            this.velocityX = maxVelocity;
                        else if (this.velocityX < -maxVelocity)
                            this.velocityX = -maxVelocity;

                        if (this.velocityY > maxVelocity)
                            this.velocityY = maxVelocity;
                        else if (this.velocityY < -maxVelocity)
                            this.velocityY = -maxVelocity;

                        // NOTE(Mølby): Min velocityX
                        if (this.velocityX > 0 && this.velocityX < haltVelocity)
                            this.velocityX = 0;
                        else if (this.velocityX < 0 && this.velocityX > -haltVelocity)
                            this.velocityX = 0;
                        else
                        {
                            // NOTE(Mølby): Dampen velocity...
                            var velocityDampened = this.velocityX * Math.pow(0.05, deltaTime);


                            if (isFinite(velocityDampened))
                            {
                                this.velocityX = velocityDampened;
                            }
                        }

                        // NOTE(Mølby): Min velocityY
                        if (this.velocityY > 0 && this.velocityY < haltVelocity)
                            this.velocityY = 0;
                        else if (this.velocityY < 0 && this.velocityY > -haltVelocity)
                            this.velocityY = 0;
                        else
                        {
                            // NOTE(Mølby): Dampen velocity...
                            var velocityDampenedY = this.velocityY * Math.pow(0.05, deltaTime);

                            if (isFinite(velocityDampenedY))
                            {
                                this.velocityY = velocityDampenedY;
                            }
                        }
                    }

                    this.velocityX += this.velocityToAddNextFrame;
                    this.velocityToAddNextFrame = 0;
                }
            }

            this.timeLastFrame = timeThisFrame;

            window.requestAnimationFrame(this.updateLoop);
        },

        appClientScaleDifference()
        {
            var appElement = document.querySelector('.aspect-ratio');
            return (parseFloat(appElement.getAttribute('data-scale')));
        },

        handleMouseDown(event)
        {
            if (this.isLoading) return;

            this.isGrabbing = true;

            this.previousMousePosition = {
                x: Math.floor(event.clientX / this.appClientScaleDifference()),
                y: Math.floor(event.clientY / this.appClientScaleDifference())
            };

            // NOTE(Mølby): This allows us to detect mouseup and move outside the browserwindow
            if (event.target.setPointerCapture)
            {
                event.target.setPointerCapture(event.pointerId);
            }
        },

        handleMouseMove(event)
        {
            event.preventDefault();

            var timeOfEvent = performance.now();

            if (this.isGrabbing)
            {
                // NOTE(Mølby): Get mouseposition in scene space
                var mousePosition = {
                    x: Math.floor(event.clientX / this.appClientScaleDifference()),
                    y: Math.floor(event.clientY / this.appClientScaleDifference())
                };

                var posX = event.clientX / this.appClientScaleDifference();
                var posY = event.clientY / this.appClientScaleDifference();

                // NOTE(Mølby): Grab offset history from last frames. And shift saved values
                this.dragLastFiveFrames[4].time = this.dragLastFiveFrames[3].time;
                this.dragLastFiveFrames[4].posX = this.dragLastFiveFrames[3].posX;
                this.dragLastFiveFrames[4].posY = this.dragLastFiveFrames[3].posY;

                this.dragLastFiveFrames[3].time = this.dragLastFiveFrames[2].time;
                this.dragLastFiveFrames[3].posX = this.dragLastFiveFrames[2].posX;
                this.dragLastFiveFrames[3].posY = this.dragLastFiveFrames[2].posY;

                this.dragLastFiveFrames[2].time = this.dragLastFiveFrames[1].time;
                this.dragLastFiveFrames[2].posX = this.dragLastFiveFrames[1].posX;
                this.dragLastFiveFrames[2].posY = this.dragLastFiveFrames[1].posY;
                
                this.dragLastFiveFrames[1].time = this.dragLastFiveFrames[0].time;
                this.dragLastFiveFrames[1].posX = this.dragLastFiveFrames[0].posX;
                this.dragLastFiveFrames[1].posY = this.dragLastFiveFrames[0].posY;

                this.dragLastFiveFrames[0].time = timeOfEvent;
                this.dragLastFiveFrames[0].posX = posX;
                this.dragLastFiveFrames[0].posY = posY;
        
                var differenceX = mousePosition.x - this.previousMousePosition.x;
                var differenceY = mousePosition.y - this.previousMousePosition.y;

				// NOTE(Mølby): Pixels dragged do not equal globe degrees/frames, so lets turn down the numbers...
				differenceX = differenceX * this.dragScaleHorisontal;
                differenceY = differenceY * this.dragScaleVertical;

                this.totalPixelsDragged += Math.abs(differenceX);

                this.previousMousePosition = mousePosition;


                // NOTE(Mølby): Horizontal dragging

                this.globeRotation.y += differenceX;

                if (this.totalPixelsDragged > 30 && !this.meaningFullDragEventEmitted)
                {
                    // NOTE(Mølby): We will use this elsewhere to disable interactions, in order to prevent openings things when just trying to drag
                    // app.radio.$emit('expo-meaningful-drag-started');
                    this.meaningFullDragEventEmitted = true;
                    // this.showDragHint = false;
                }

                this.globeRotation.y = this.wrapRotationY(this.globeRotation.y);


                // NOTE(Mølby): Vertical dragging
                this.globeRotation.x += differenceY;
                this.globeRotation.x = this.clampRotationX(this.globeRotation.x);
                // NOTE(Mølby): CLAMP

                // NOTE(Mølby): Set tutorial as completed
                if (this.isTutorial && this.totalPixelsDragged > 7)
                {
                    this.tutorialHasBeenPassed = true;
                    store.setGlobeState('normal');
                }
            }
        },
        
        handleMouseUp(event)
        {
            this.isGrabbing = false;
            this.totalPixelsDragged = 0;
            this.meaningFullDragEventEmitted = false;

            var dragDuration = this.dragLastFiveFrames[0].time - this.dragLastFiveFrames[4].time;
            var dragDistanceX = this.dragLastFiveFrames[0].posX - this.dragLastFiveFrames[4].posX;
            var dragDistanceY = this.dragLastFiveFrames[0].posY - this.dragLastFiveFrames[4].posY;

            // NOTE(Mølby): Prevent velocity if some time has passed since last dragframe
            var currentTime = performance.now();

            const timeToAllowVelocityMs = 75;
            var timeOfRelease = this.dragLastFiveFrames[0].time + timeToAllowVelocityMs;

            var dragWasStoppedBeforeRelease = (timeOfRelease < currentTime);
            if (dragWasStoppedBeforeRelease)
            {
                this.velocityX = 0;
                this.velocityY = 0;
            }
            else
            {
                var velocityX = dragDistanceX / (dragDuration / 1000);
                this.velocityX = velocityX * this.dragScaleHorisontal;

                var velocityY = dragDistanceY / (dragDuration / 1000);
                this.velocityY = velocityY * this.dragScaleVertical;
            }

            // NOTE(Mølby) Clear drag data
            this.dragLastFiveFrames = [
                {time: 0, posX: 0, posY: 0},
                {time: 0, posX: 0, posY: 0},
                {time: 0, posX: 0, posY: 0},
                {time: 0, posX: 0, posY: 0},
                {time: 0, posX: 0, posY: 0}
            ];

            // NOTE(Mølby): This allows us to detect mouseup and move outside the browserwindow
            if (event.target.releasePointerCapture)
            {
                event.target.releasePointerCapture(event.pointerId);
            }
        },

        wrapRotationY(globeRotationY)
        {
            var newGlobeRotationY = globeRotationY;

            if (newGlobeRotationY < 0)
            {
                // NOTE(Mølby): Wrap around this way: >
                newGlobeRotationY = 359 + newGlobeRotationY;
            }
			else if (newGlobeRotationY > 359)
			{
				newGlobeRotationY = newGlobeRotationY - 359;
			}

			// NOTE(Mølby): Final check
			if (newGlobeRotationY < 0 || newGlobeRotationY > 359)
			{
				newGlobeRotationY = this.wrapRotationY(newGlobeRotationY);
			}

            return newGlobeRotationY;
        },

        clampRotationX(globeRotationX)
        {
            var newGlobeRotationX = globeRotationX;

            var maxVerticalRotation = 35;

            if (newGlobeRotationX < -maxVerticalRotation) newGlobeRotationX = -maxVerticalRotation;
            else if (newGlobeRotationX > maxVerticalRotation) newGlobeRotationX = maxVerticalRotation;

            return newGlobeRotationX;
        }
	}
}
</script>